import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  medicalCentersListData: []
};

const MedicalCentersListReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  if (type === ACTION_TYPES.CREATE_MEDICALCENTERSLIST) {
    return {
      ...state,
      medicalCentersListData: payload
    };
  }
  return state;
};

export default MedicalCentersListReducer;
